const {
    _getAllIndexesOwnedByAUser,
    _getPersonalIndex,
    _knotToStakehouse,
	_getAllEventsForAKnot
} = require('../logic/subgraph');

class SubgraphSubPackage {

	constructor(signer) {
		this.etherSigner = signer;
	}

	getAllIndexesOwnedByAUser(userAddress) {
		return _getAllIndexesOwnedByAUser(this.etherSigner, userAddress);
	}
	
    getPersonalIndex(userAddress) {
		return _getPersonalIndex(this.etherSigner, userAddress);
	}
	
    knotToStakehouse(id) {
		return _knotToStakehouse(this.etherSigner, id);
	}

	getAllEventsForAKnot(blsPublicKey) {
		return _getAllEventsForAKnot(this.etherSigner, blsPublicKey);
	}
}

module.exports = {
    SubgraphSubPackage
};
